// src/utils/numberGenerator.ts

import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';

// 기관별 의사번호 생성 (D + 기관번호 뒤 4자리 + 순번)
export const generateDoctorNumber = async (institutionNumber: string): Promise<string> => {
  try {
    // 기관번호 뒤 4자리 추출
    const institutionSuffix = institutionNumber.slice(-4).padStart(4, '0');
    
    // 해당 기관의 기존 의사 수 조회
    const q = query(
      collection(db, 'doctors'),
      where('institutionNumber', '==', institutionNumber)
    );
    
    const querySnapshot = await getDocs(q);
    const existingDoctorsCount = querySnapshot.size;
    
    // 새로운 순번 (기존 의사 수 + 1)
    const sequence = (existingDoctorsCount + 1).toString().padStart(3, '0');
    
    // D + 기관번호뒤4자리 + 순번3자리
    const doctorNumber = `D${institutionSuffix}${sequence}`;
    
    // 중복 확인
    const duplicateCheck = query(
      collection(db, 'doctors'),
      where('institutionNumber', '==', institutionNumber),
      where('doctorNumber', '==', doctorNumber)
    );
    
    const duplicateSnapshot = await getDocs(duplicateCheck);
    
    if (!duplicateSnapshot.empty) {
      // 중복이 있으면 재귀적으로 다음 번호 생성
      return generateDoctorNumber(institutionNumber);
    }
    
    return doctorNumber;
  } catch (error) {
    console.error('의사번호 생성 오류:', error);
    // 오류 시 랜덤 번호 생성
    const timestamp = Date.now().toString().slice(-5);
    return `D${institutionNumber.slice(-4)}${timestamp}`;
  }
};